<script>
import _ from 'lodash'
import getMarkerColor from '../../utils/getMarkerColor'
import { normalizeRange } from '../../utils/biomarker'
import { getBlocks } from '../../utils/charts'

export default {
  name: 'ReferenceRangeChart',
  props: {
    range: {
      type: Object,
      required: true
    },
    result: {
      type: Number
    }
  },
  computed: {
    getBlocks() {
      return getBlocks(normalizeRange(this.range), this.result)
    }
  }
}
</script>

<template>
  <div class="lab-chart-wrapper">
    <div
      v-for="block in getBlocks"
      :class="{ 'lc-block': true, active: block.isActive }"
      :key="block.min"
      :style="{
        width: block.size + '%'
      }"
    >
      <div v-if="block.isActive" class="wrapper">
        <div class="mark" :style="{ left: block.markPosition + '%' }" />
      </div>
      <div
        class="lc-block--filler"
        :style="{
          backgroundColor: block.color
        }"
      />
      <div v-if="block.isNormal" class="lc-block--range has-text-tertiary">
        <span>{{ block.min }}</span>
        <span class="is-pulled-right">{{ block.max }}</span>
      </div>
    </div>
  </div>
</template>

<style lang="sass" scoped>
.lab-chart-wrapper
  position: relative
  display: flex
  height: 48px
  margin-top: -6px

.lc-block
  margin: 0 1px
  &:last-child
    margin: 0 0 0 1px
  &:first-child
    margin: 0 1px 0 0
  &.active > .lc-block--filler
    opacity: 0.85
  .lc-block--filler
    margin-top: 20px
    height: 8px
    width: 100%
    border-radius: 3px
    opacity: 0.3
  .lc-block--range
    width: 100%
    height: 20px
    line-height: 20px
    font-size: 0.8rem

.wrapper
  width: 100%
  padding: 0 1px
  z-index: 25
  position: relative

.mark
  position: absolute
  width: 15px
  height: 15px
  border-radius: 50% 50% 50% 0
  border: 0.5px solid #fff
  background: #004953
  transform: rotate(-45deg)
  margin-top: 5px
  margin-left: -8px
</style>
